import React from "react";

import {LoadingOverlay} from "../../components/LoadingOverlay";
import AccommodationsProvider, {useAccommodationsPage} from "./AccommodationContext";
import Home from "./Home";
import FormCreateHome from "./FormCreateHome";

const Accommodations = () => {
    return (
        <AccommodationsProvider>
            <AccommodationContent/>
        </AccommodationsProvider>
    );
}

const AccommodationContent = () => {
    const {isLoading, formCreateHome} = useAccommodationsPage();

    return <LoadingOverlay isLoading={isLoading} size="large">
        <Home/>
        {formCreateHome.show && <FormCreateHome/>}
    </LoadingOverlay>
}

export default Accommodations;